import { render, staticRenderFns } from "./InvalidPage.vue?vue&type=template&id=f6a25810&scoped=true&"
import script from "./InvalidPage.vue?vue&type=script&lang=js&"
export * from "./InvalidPage.vue?vue&type=script&lang=js&"
import style0 from "./InvalidPage.vue?vue&type=style&index=0&id=f6a25810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a25810",
  null
  
)

export default component.exports